import { ClientScreen, ClientService } from '~app-client/core/services';
import { SpotlightConfigItem, SpotlightConfigItemScrens } from '~app-client/onboarding/types';

const ALL_ITEM_KEYS: Array<keyof SpotlightConfigItemScrens<unknown>> = [
	'base',
	'mobile',
	'desktop',
];

export function getConfigItem<T>(items: SpotlightConfigItem<T>, screen?: ClientScreen): T {
	const cleanScreen = screen ?? ClientService.screen;

	try {
		const itemKeys = Object.keys(items as Record<string, unknown>);
		const usingScreenKeys = ALL_ITEM_KEYS.filter((key) => itemKeys.includes(key)).length > 0;
		if (usingScreenKeys) {
			const { base, desktop, mobile } = items as SpotlightConfigItemScrens<T>;
			const specificItem = cleanScreen === ClientScreen.DESKTOP ? desktop : mobile;

			if (!specificItem) {
				return base;
			}

			if (Array.isArray(base) && Array.isArray(specificItem)) {
				return [...base, ...specificItem] as T;
			}

			return specificItem;
		}
	} catch {
		// ignore
	}

	return items as T;
}
